$(document).ready(function() {
    var distanceFromTop = $(document).scrollTop();
    if (distanceFromTop >= 50) {
        $('nav').addClass('bg-light-dark');
    } else {
        $('nav').removeClass('bg-light-dark');
    }

    $(window).scroll(function() {
        var distanceFromTop = $(document).scrollTop();
        if (distanceFromTop >= 50) {
            $('nav').addClass('bg-light-dark');
        } else {
            $('nav').removeClass('bg-light-dark');
        }
    });

    $(".hamburger").click(function() {
        var distanceFromTop = $(document).scrollTop();
        if (distanceFromTop < 50) {
            $("nav").toggleClass("bg-light-dark")
        }
    });
});
